import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
// import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
// import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
// import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
// import { ActivatedRoute } from '@angular/router';
// import { CommissionsReportComponent } from 'src/app/modules/reports/commissions-report/commissions-report.component';
// import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
// import * as _ from "lodash";
// import { NotificationService } from 'src/app/services/notification-service';

@Component({
    selector: 'app-multi-input-fields',
    templateUrl: './multi-input-fields.component.html',
    styleUrls: ['./multi-input-fields.component.scss'],

})
export class MultiInputFieldsComponent implements OnInit {
    urlName: any;
    componentName: any;
    @Input() range: any;
    minDate: Date;
    @Output() rangeEvent = new EventEmitter();
    // ServiceProviderList: any = [];
    // dropdownSettings: any = {};
    // ApplicationStatusList: any = [];
    // ResellerCodeList: any = [];
    // SalesCodeList: any = [];

    constructor(
        // private ActivateRoute: ActivatedRoute, private injector: Injector,
        // private lookUpService: LookupDataServiceService, private fb: FormBuilder, private toastr: NotificationService

    ) {
        // this.urlName = this.ActivateRoute.snapshot.url[0].path
        // this.componentName = this.injector.get(CommissionsReportComponent)
    }

    ngOnInit(): void {

        // this.dropdownSettings = {
        //     singleSelection: false,
        //     idField: "key",
        //     textField: "value",
        //     selectAllText: "Select All",
        //     unSelectAllText: "UnSelect All",
        //     allowSearchFilter: true,
        // };
        // this.init()

        // debugger
        // this.urlName
        // if (this.urlName == 'commissionsreports') {
        //     this.componentName = this.injector.get(CommissionsReportComponent);
        //     this.getServiceProvider()
        //     this.getApplicationStausType()
        //     this.getResellerList()
        //     this.getManageSalesRepList()
        // }
        this
    }
    // init() {
    //     this.range = this.fb.group({
    //         approvedApplicationstartdate: [null, Validators.required],
    //         approvedApplicationEnddate: [null, Validators.required],
    //         firstName: [''],
    //         lastName: [''],
    //         applicationReferenceNumber: [''],
    //         customerReferenceNumber: [''],
    //         serviceProviderIdList: [''],
    //         applicationStatuslist: [''],
    //         resellerCodeList: [''],
    //         salesRepCodelist: [''],
    //         applicationCancelRestrict: [false]
    //     });
    // }

    // openDatePicker(id) {
    //     const clickEvent = new Event('click');
    //     const elementToClick = document.getElementById(id);
    //     if (elementToClick) {
    //         elementToClick.dispatchEvent(clickEvent);
    //     }
    // }
    // getServiceProvider() {
    //     this.lookUpService.getServiceProvider().subscribe(res => {
    //         this.ServiceProviderList = _.orderBy(res, ["value"], ["asc"]);
    //     })
    // }
    // getApplicationStausType() {
    //     this.lookUpService.getApplicationStausType().subscribe(res => {
    //         this.ApplicationStatusList = _.orderBy(res, ["value"], ["asc"]);
    //     })
    // }
    // getResellerList() {
    //     this.lookUpService.getResellerList().subscribe(res => {
    //         this.ResellerCodeList = _.orderBy(res, ["value"], ["asc"]);
    //     })
    // }
    // getManageSalesRepList() {
    //     this.lookUpService.getManageSalesRepList().subscribe(res => {
    //         this.SalesCodeList = _.orderBy(res, ["value"], ["asc"]);
    //     })
    // }
    Submit() {
      this.rangeEvent.emit(this.range)
    }
    clearFilter() {
        // this.init()
    }

}
